export default __webpack_public_path__ + "img/cfdeb1dac91c9bd06929dce788bebf51.png";